import { lazy } from '../../shared/deployment';

export const JmeCarousel = lazy(() => import('./JmeCarousel'));
export const JmeCarouselData = lazy(() => import('./JmeCarouselData'));
export const JmeArrow = lazy(() => import('./JmeArrow'));
export const JmeTagsFilterCarousel = lazy(() => import('./JmeTagsFilterCarousel'));
export const CarouselWithThumbnails = lazy(() => import('./CarouselWithThumbnails'));
